import React from 'react';
import {
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Portal,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useTranslation } from 'i18n/TranslationProvider';
import API from 'api/api';

const LanguageSelector = ({ size = 'sm', variant = 'outline', showLabel = false }) => {
  const { t, language, setLanguage, languages } = useTranslation();
  const currentLang = languages.find((lang) => lang.code === language);
  const menuBg = useColorModeValue('white', 'navy.800');

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={Button}
        size={size}
        variant={variant}
        rightIcon={<ChevronDownIcon />}
        aria-label={t('Select language')}
      >
        <HStack spacing={2}>
          {showLabel && (
            <Text as="span" fontSize="xs" color="gray.500" textTransform="uppercase">
              {t('Language')}
            </Text>
          )}
          <Text as="span">{currentLang?.label || language.toUpperCase()}</Text>
        </HStack>
      </MenuButton>

      <Portal>
        <MenuList
          maxH="320px"
          overflowY="auto"
          bg={menuBg}
          zIndex={2000}
        >
          <MenuItem
            fontWeight="semibold"
            pointerEvents="none"
            opacity={0.7}
            fontSize="xs"
            textTransform="uppercase"
          >
            {t('Select language')}
          </MenuItem>
          <MenuDivider />
          {languages.map((lang) => (
            <MenuItem
              key={lang.code}
              onClick={() => {
                setLanguage(lang.code);
                API.patch('/users/me/translation-preferences', { preferredLanguage: lang.code }).catch(() => {});
              }}
              fontWeight={lang.code === language ? 'semibold' : 'normal'}
            >
              {lang.label}
            </MenuItem>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default LanguageSelector;
